import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引用element
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
// 引用轮播插件
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'animate.css'
Vue.use(VueAwesomeSwiper)
// 全局引用axios
import axios from 'axios'
Vue.prototype.$axios = axios
//默认的contenttype为json以及utf-8；
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
//指定baseURL
// axios.defaults.baseURL = 'http://192.168.1.233:7004';

// 全局引用公共js
import global_ from './assets/js/common.js';
Vue.prototype.GLobal =global_

import VueVideoPlayer from 'vue-video-player'
// require videojs style
import 'video.js/dist/video-js.css'
// import 'vue-video-player/src/custom-theme.css'
Vue.use(VueVideoPlayer)

Vue.config.productionTip = false

router.beforeEach((to,from,next)=>{
    if(to.name=="video"){
        const token=store.state.login ? store.state.login : window.sessionStorage.getItem("token");
        window.sessionStorage.setItem("url",'video')
        if(!token){
            next({
                path:'/login'
            })
        }else{
            next()
        }
    }else if(to.name=="document"){
        const token=store.state.login ? store.state.login : window.sessionStorage.getItem("token");
        window.sessionStorage.setItem("url",'document')
        if(!token){
            next({
                path:'/login'
            })
        }else{
            next()
        }
    }else{
        next()
    }

})

//路由跳转后，页面回到顶部
router.afterEach(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
